import React from 'react';
import { clsx } from 'clsx';
import { Loader2 } from 'lucide-react';

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  loading?: boolean;
  label?: React.ReactNode;
  /** Texto do `aria-label` quando não há rótulo visível. */
  ariaLabel?: string;
  className?: string;
}

/** Interruptor liga/desliga (role="switch") no padrão emerald da identidade visual. */
export const Switch: React.FC<SwitchProps> = ({ checked, onChange, disabled, loading, label, ariaLabel, className }) => {
  const blocked = disabled || loading;
  return (
    <label className={clsx('inline-flex items-center gap-2 select-none', blocked ? 'cursor-not-allowed' : 'cursor-pointer', className)}>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel}
        disabled={blocked}
        onClick={() => onChange(!checked)}
        className={clsx(
          'relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-1',
          checked ? 'bg-emerald-600' : 'bg-slate-300',
          blocked && 'opacity-60',
        )}
      >
        <span
          className={clsx(
            'inline-flex h-5 w-5 items-center justify-center rounded-full bg-white shadow transform transition-transform',
            checked ? 'translate-x-5' : 'translate-x-0.5',
          )}
        >
          {loading && <Loader2 size={12} className="animate-spin text-slate-500" />}
        </span>
      </button>
      {label && <span className="text-sm text-slate-700">{label}</span>}
    </label>
  );
};

export default Switch;
